import React from "react";
import useReactRouter from "use-react-router";
import ReactPaginate from "react-paginate";

//* One look for every pager in the app.
const PAGER_PROPS = {
  previousLabel: "ກັບຄືນ",
  nextLabel: "ຕໍ່ໄປ",
  breakLabel: "...",
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 2,
  renderOnZeroPageCount: null,
  containerClassName: "pagination justify-content-center",
  pageClassName: "page-item",
  pageLinkClassName: "page-link",
  previousClassName: "page-item",
  previousLinkClassName: "page-link",
  nextClassName: "page-item",
  nextLinkClassName: "page-link",
  breakClassName: "page-item",
  breakLinkClassName: "page-link",
  activeClassName: "active",
};

const PaginationHelper = () => {
  const { history, match } = useReactRouter();
  const _limit = parseInt(match?.params?.limit);
  const _skip = parseInt(match?.params?.skip);

  const Pagination_helper = (total, rout, filtter) => {
    const handlePageClick = async (envent) => {
      let currentPage = envent.selected + 1;
      history.push(rout + "/limit/" + _limit + "/page/" + currentPage, filtter);
    };
    return (
      <ReactPaginate
        {...PAGER_PROPS}
        onPageChange={handlePageClick}
        pageCount={Math.ceil(total / _limit)}
        // pageRangeDisplayed={7}
        forcePage={_skip - 1}
      />
    );
  };

  /**
   * The same pager for a list whose page lives in component state rather than in the URL, and
   * whose page count may grow (the Facebook feed only says whether there is a next page).
   * `pageIndex` is 0-based; `onChange` gets the 0-based page picked.
   */
  const Pagination_state = (pageCount, pageIndex, onChange) => (
    <ReactPaginate
      {...PAGER_PROPS}
      onPageChange={(e) => onChange(e.selected)}
      pageCount={pageCount}
      forcePage={pageIndex}
    />
  );

  return {
    _limit,
    _skip,
    Pagination_helper,
    Pagination_state,
  };
};
export default PaginationHelper;
